import React, { useState } from 'react';
import Swal from 'sweetalert2';
import { safeStorage } from '../utils/safeStorage';
import './addName.css';

function AddName({ onAdd, onGenerateTickets }) {
  const [collectedNames, setCollectedNames] = useState([]);

  const handlePurchaseClick = async () => {
    const { value: numberOfEntries } = await Swal.fire({
      title: 'Quantas entradas deseja comprar?',
      input: 'number',
      inputLabel: 'Insira a quantidade desejada',
      inputAttributes: {
        min: 1,
        step: 1,
      },
      showCancelButton: true,
      confirmButtonText: 'Confirmar',
      cancelButtonText: 'Cancelar',
    });

    if (numberOfEntries) {
      const count = parseInt(numberOfEntries, 10);

      const { isConfirmed, value: names } = await Swal.fire({
        title: 'Insira os nomes',
        html: Array(count)
          .fill('')
          .map(
            (_, index) =>
              `<input id="input-${index}" type="text" class="swal2-input" placeholder="Nome completo (IDENTICO AO RG)- ${index + 1}">`
          )
          .join(''),
        focusConfirm: false,
        showCancelButton: true,
        confirmButtonText: 'Inserir nomes',
        preConfirm: () => {
          try {
            const inputs = [];
            for (let i = 0; i < count; i++) {
              const input = document.getElementById(`input-${i}`);
              if (!input) {
                console.error(`Input ${i} não encontrado`);
                continue;
              }
              const value = input.value.trim();
              inputs.push(value);
            }

            const hasEmpty = inputs.some((name) => name === '');
            if (hasEmpty) {
              Swal.showValidationMessage('Por favor, preencha todos os campos.');
              return false;
            }

            return inputs;
          } catch (error) {
            console.error('Erro ao coletar inputs:', error);
            return false;
          }
        },
      });

      if (isConfirmed && Array.isArray(names)) {
        // Salva o estado atual dos eventos
        const currentSelectedDays = safeStorage.getItem('selectedDays');
        const currentSelectedOptions = safeStorage.getItem('selectedOptions');

        // Atualiza os nomes
        setCollectedNames(names);
        safeStorage.setItem('collectedNames', JSON.stringify(names));
        onAdd(names);

        // Restaura o estado dos eventos após um pequeno delay
        setTimeout(() => {
          if (currentSelectedDays) safeStorage.setItem('selectedDays', currentSelectedDays);
          if (currentSelectedOptions) safeStorage.setItem('selectedOptions', currentSelectedOptions);
        }, 100);
      }
    }
    // handleGenerateTicketsClick()
  };

  // eslint-disable-next-line no-unused-vars -- reservado para uso futuro
  const handleGenerateTicketsClick = async () => {
    const storedNames = safeStorage.getItem('collectedNames');
    const names = storedNames ? JSON.parse(storedNames) : collectedNames;

    if (!names || names.length === 0) {
      alert('Por favor, adicione o nome completo.');
      return;
    }

    // Garante um atraso para sincronizar e exibir carregamento
    await Swal.fire({
      title: 'Aguarde...',
      text: 'Gerando pagamento...',
      timer: 5000,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    // Após o carregamento, chama a função de geração de tickets
    if (onGenerateTickets) {
      onGenerateTickets(names);
    }
  };

  return (
    <div className='add-name'>
      <h2>Primeiro, selecione quantas entradas deseja comprar </h2>
      <button onClick={handlePurchaseClick}>Inserir Nomes</button>

      {/* <button onClick={handleGenerateTicketsClick}>Comprar Entradas</button> */}
    </div>
  );
}

export default AddName;

